import { render, staticRenderFns } from "./WorkflowRoleNew.vue?vue&type=template&id=3e04ffae"
import script from "./WorkflowRoleNew.vue?vue&type=script&lang=js"
export * from "./WorkflowRoleNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports